import { useState, useEffect, useRef } from 'react'
import Box from '@mui/joy/Box'
import { TemplateEditor } from '../components/TemplateEditor.js'
import { useNavigate } from 'react-router-dom'
import { canvasActions } from '../common/canvasActions'
import { canvasUtils } from '../common/canvasUtils'
import { TEMPLATE_EDITOR_FUNC_MAP } from '../common/utils'
import { TemplateAPI } from '../api/TemplateAPI'
import { BlobAPI } from '../api/BlobAPI'
import { useParams } from 'react-router-dom'
import _ from 'lodash'

const INT_TYPE_MAP = {
    100: TEMPLATE_EDITOR_FUNC_MAP.QUOTE,
    200: TEMPLATE_EDITOR_FUNC_MAP.BLOG,
    300: TEMPLATE_EDITOR_FUNC_MAP.LISTING,
}

export const LibraryTemplateEditor = () => {
    const [canvas, setCanvas] = useState(null)
    const [error, setError] = useState(null)
    const [title, setTitle] = useState(null)
    const { templateId } = useParams()
    const navigate = useNavigate()
    const funcMap = useRef(null)

    useEffect(() => {
        TemplateAPI.get(templateId)
            .then((response) => {
                setCanvas(response.data.canvas)
                setTitle(response.data.title)
                funcMap.current = INT_TYPE_MAP[response.data.type]
            })
            .catch((e) => {
                console.log(e)
            })
    }, [])

    const saveTemplate = (title, canvas) => {
        let screenshot = canvasActions.takeScreenshot(canvas)
        const blob = canvasUtils.dataUrlToBlob(screenshot)

        funcMap.current
            .update(templateId, title, blob, JSON.stringify(canvas.toJSON()))
            .then((response) => {
                window.location.reload()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    const handleSave = (title, canvas) => {
        if (!title) {
            setError('Please title the template')
            return
        }
        let result = funcMap.current.validate(canvas.toJSON())
        if (!result.isValid) {
            setError(result.reason)
            return
        }

        const newImages = canvasUtils.mapNewImages(canvas)
        if (_.isEmpty(newImages)) {
            saveTemplate(title, canvas)
            return
        }

        let urlsBody = Object.entries(newImages).map(([uid, file]) => {
            return { filename: file.name, mime_type: file.type }
        })

        BlobAPI.getPresignedUrlV2(urlsBody).then((response) => {
            let promises = []
            let presignMap = {}
            response.data.urls.forEach((presign) => {
                Object.entries(newImages).forEach(([uid, file]) => {
                    if (presign.filename === file.name) {
                        promises.push(BlobAPI.uploadBlob(presign.url, file))
                        presignMap[uid] =
                            `${presign.url.url}${presign.url.fields.key}`
                    }
                })
            })
            Promise.all(promises).then(() => {
                const swapPromises = canvasUtils
                    .getImages(canvas)
                    .map((img) => {
                        const newUrl = presignMap[img.id]
                        if (!newUrl) {
                            return null
                        }

                        return new Promise((resolve, reject) => {
                            img.set({ crossOrigin: 'anonymous' })
                            img.setSrc(
                                newUrl,
                                (img) => {
                                    if (!img._element) {
                                        return reject(
                                            new Error(
                                                `Failed to load ${newUrl}`
                                            )
                                        )
                                    }
                                    resolve()
                                },
                                { crossOrigin: 'anonymous' }
                            )
                        })
                    })
                    .filter(Boolean)

                Promise.all(swapPromises).then(() => {
                    saveTemplate(title, canvas)
                })
            })
        })
    }

    return (
        <>
            <TemplateEditor
                key={title}
                canvasJSON={canvas}
                templateTitle={title}
                onSave={handleSave}
                onExit={() => navigate('/merchant/template_library')}
                errorMsg={error}
            />
        </>
    )
}
